export function capitalizeFirstLetter(str: string) {
	return str.charAt(0).toUpperCase() + str.slice(1);
}

export function clip(str: string, length: number, suffix = '...') {
	if (str.length <= length) {
		return str;
	}

	return str.slice(0, length).concat(suffix);
}

export function formatUserName(firstName = '', lastName = ''): string {
	const strings: string[] = [capitalizeFirstLetter(lastName), capitalizeFirstLetter(firstName)];
	return strings.join(', ');
}

/**
 * Parses a string (optional) into an array of numbers, splitting by the specified delimiter.
 * Optionally filters out any values that cannot be converted to valid numbers.
 *
 * @param {Object} params - The parameters object
 * @param {string} params.input - The string to parse
 * @param {string} [params.delimiter=','] - The delimiter to split the string by
 * @param {boolean} [params.filterNaN=true] - Whether to filter out NaN values
 * @returns {number[]} Array of valid numbers
 */
export function parseNumberList({ input, delimiter = ',', filterNaN = true }: { input?: string; delimiter?: string; filterNaN?: boolean }): number[] {
	if (!input) { return []; }
	const numbers = input.split(delimiter).map(n => Number(n));
	return filterNaN ? numbers.filter(n => !isNaN(n)) : numbers;
}
